/**
 * About Page
 */

import Layout from '@components/layout/Layout'

export default function About() {
  return (
    <Layout heroImage="/images/hero/unicorn-pagasus.webp" heroAlt="A note from me">
      <h1>A note from me</h1>
      <div className="about-content">
        <div className="book-grid">
          <div className="card book-card">
            <p>
              I've been working very hard on Rocketship Readers. I hope you enjoyed my website.
              Have an awesome day!
            </p>
            <p>Love,<br></br>
            Angelina</p>
            <h2>About me</h2>
            <p>
              I first got the idea of Rocketship readers when I was on vacation with my best
              friend Victoria. We were writing books, and then I started writing
              Rocketship Readers Level 2 Blastoff in the back of the book. It was very fun, and
              that is when I got the idea.
            </p>
            <p>
              
              It's been a couple of years since I first created Rocketship Readers, and now, 
              coming back to it, I saw so many things I could change. That's the reason it is 
              important to look at things with a new perspective.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  )
}
